import { Card, Icon, IconProps } from 'pounceV2';
import { DetectionType } from 'Generated/schema';
import React from 'react';
import LogProviderIconByLogTypeV3 from 'Pages/Configure/components/LogProviderIconByLogTypeV3';

interface NodeIconProps {
  analysisType: DetectionType;
  logTypes?: string[];
}

const NodeIconV3 = ({ analysisType, logTypes }: NodeIconProps) => {
  const iconProps = React.useMemo(() => {
    if (analysisType === DetectionType.Rule && logTypes?.length > 1) {
      return { 'data-testid': 'many-log-types-icon', type: 'summary' };
    }

    if (analysisType === DetectionType.CorrelationRule) {
      return { 'data-testid': 'correlation-rule-icon', type: 'correlation-rule' };
    }

    if (analysisType === DetectionType.ScheduledRule) {
      return { 'data-testid': 'scheduled-rule-icon', type: 'scheduled-rule' };
    }

    return { 'data-testid': 'default-icon', type: 'detection' };
  }, [analysisType, logTypes]);

  return (
    <Card variant="midToWhite" p={1}>
      {analysisType === DetectionType.Rule && logTypes?.length === 1 ? (
        <LogProviderIconByLogTypeV3 logType={logTypes[0]} />
      ) : (
        <Icon size="large" m="auto" display="block" {...(iconProps as IconProps)} />
      )}
    </Card>
  );
};

export default NodeIconV3;
